import React from 'react';
import styled from 'styled-components';

interface TabPaneProps {
    tabKey: string;
    children: React.ReactNode;
}

const Pane = styled.div<{ $active: boolean }>`
    position: absolute;
    top: 0;
    left: 0;
    z-index: ${(props) => (props.$active ? 1000 : 0)};
    opacity: ${(props) => (props.$active ? 1 : 0)};
    visibility: ${(props) => (props.$active ? 'visible' : 'hidden')};
    pointer-events: ${(props) => (props.$active ? 'auto' : 'none')};
    transition:
        opacity 0.5s,
        visibility 0.5s;
    display: flex;
    flex: 1;
    width: 100%;
    height: 100%;
    min-height: 0;
    min-width: 0;

    .ant-spin-nested-loading,
    .ant-spin-container {
        flex: 1;
        display: flex;
        min-height: 0;
        min-width: 0;
        flex-direction: column;
    }
`;

export const TabPane: React.FC<TabPaneProps> = ({ tabKey, children }) => {
    const { tab, visitedTabs } = React.useContext(TabsContext);
    const isActive = tab === tabKey;
    const visited = visitedTabs.has(tabKey);

    if (!visited) {
        return null;
    }

    return <Pane $active={isActive}>{children}</Pane>;
};

interface CustomTabsProps {
    tab: string;
    children: React.ReactNode;
}

interface TabsContextType {
    tab: string;
    visitedTabs: Set<string>;
}

const TabsContext = React.createContext<TabsContextType>({
    tab: '',
    visitedTabs: new Set(),
});

export const Tabs: React.FC<CustomTabsProps> = ({ tab, children }) => {
    const [visitedTabs, setVisitedTabs] = React.useState(new Set([tab]));

    React.useEffect(() => {
        setVisitedTabs((prev) => new Set(prev).add(tab));
    }, [tab]);

    return (
        <TabsContext.Provider value={{ tab, visitedTabs }}>
            <div
                style={{
                    position: 'relative',
                    display: 'flex',
                    flex: 1,
                    height: '100%',
                    flexDirection: 'column',
                    minHeight: 0,
                    minWidth: 0,
                    overflow: 'hidden',
                }}
            >
                {children}
            </div>
        </TabsContext.Provider>
    );
};
